module.exports = __webpack_public_path__ + "public/images/header/burger-menu.e7ada0c0aebc3ffe2eafaeb986defb0f.svg";